import React, { useState } from "react";
import { PageTitle } from "domain/feature/hub/pageTitle/styles";
import { trans } from "sharedKernel/i18n";
import { useSmartNavigateLegacy as useNavigate } from "components/SmartLink";
import { Button, Col, Row } from "react-bootstrap";
import { NoContent } from "components/NoContent";
import NoContentImg from "assets/images/defaults/school.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterOrderBar } from "sharedKernel/styledComponents/filterComponents/style";
import { Filter } from "components/Filter";
import { FilterOrderByProps, OrderBy } from "components/OrderBy";
import { Track, TrackContainer } from "domain/track/trackContainer";
import { useAvailableTracksList } from "./hooks/useAvailableTracksList";
import { Loading } from "components/loading";

export const TracksAvailablePage = ({ ...props }): JSX.Element => {
  const orderByOptions = [
    {
      value: "title asc",
      label: trans("Ordem alfabética"),
    },
    {
      value: "updated_at desc",
      label: trans("Mais recente"),
    },
  ];
  
  const navigate = useNavigate();
  const [selectedOrderBy, setSelectedOrderBy] = useState(orderByOptions[0]);
  const [currentSearchTerm, setCurrentSearchTerm] = useState<string>("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);

  const labels = {
    noContent: trans("Nenhuma trilha disponível no momento"),
    title: trans("Trilhas Disponíveis"),
  };

  const { data, isLoading, error, refetch } = useAvailableTracksList(currentPage, limit, selectedOrderBy.value);

  const onOrderBy = (selectedOrderBy: FilterOrderByProps): void => {
    setSelectedOrderBy(selectedOrderBy);
    refetch();
  };

  const onSearch = (searchTerm: string): void => {
    setCurrentSearchTerm(searchTerm);
    refetch();
  };

  const FilterOrderBarElement = (): JSX.Element => {
    return (
      <FilterOrderBar>
        <Filter currentSearchTerm={currentSearchTerm} btnClick={onSearch} />
        <OrderBy
          selectedValue={selectedOrderBy}
          onSelect={onOrderBy}
          options={orderByOptions}
        />
      </FilterOrderBar>
    );
  };

  const openTrack = (id: string | number, t: Track): void => {
    navigate(`/hub/available-tracks/details/${id}`, { state: { track: t } });
  };

  if (isLoading) {
    return (
      <>
        <Row className="align-items-center">
          <Col>
            <PageTitle>{labels.title}</PageTitle>
          </Col>
        </Row>
        <Loading />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Row className="align-items-center">
          <Col>
            <PageTitle>{labels.title}</PageTitle>
          </Col>
        </Row>
        <div className="text-center py-5">
          <FontAwesomeIcon icon={["fas", "exclamation-triangle"]} className="me-2 text-warning" />
          <p className="text-danger">{error}</p>
          <Button variant="outline-primary" onClick={refetch}>
            Tentar novamente
          </Button>
        </div>
      </>
    );
  }

  return (
    <>
      <Row className="align-items-center">
        <Col>
          <PageTitle>{labels.title}</PageTitle>
        </Col>
      </Row>
      {data && data.rows && data.rows.length > 0 && (
        <Row>
          <FilterOrderBarElement />
        </Row>
      )}
      {!data || !data.rows || data.rows.length === 0 ? (
        <NoContent text={labels.noContent} image={NoContentImg} />
      ) : (
        <TrackContainer
          tracks={data.rows}
          getInfoItems={(t) => [
            {
              icon: (
                <FontAwesomeIcon className="fa-icon" icon={["fas", "book"]} />
              ),
              text: `${t.lessons || t.numberOfLessons} aulas`,
            },
            {
              icon: (
                <FontAwesomeIcon className="fa-icon" icon={["far", "clock"]} />
              ),
              text: `${t.length || t.totalOfMinutes} minutos`,
            },
          ]}
          getActions={(t) => [
            {
              label: "Ver trilha",
              kind: "primary",
              onClick: () => openTrack(t.id, t),
            },
          ]}
        />
      )}
    </>
  );
};
